import { render, staticRenderFns } from "./shopstaff.vue?vue&type=template&id=28d191a1&scoped=true&"
import script from "./shopstaff.vue?vue&type=script&lang=js&"
export * from "./shopstaff.vue?vue&type=script&lang=js&"
import style0 from "./shopstaff.vue?vue&type=style&index=0&id=28d191a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d191a1",
  null
  
)

export default component.exports